import { RecordHistoryPage } from '@/components/audit-log/RecordHistoryPage'
import { usePathHelper } from '@/hooks/usePathHelper'
import { adminTitleHead } from '@/lib/admin-route-title'
import { auditLogQueries } from '@/lib/services/audit-log/audit-log.query'
import { organizationTaxSettingsQueries } from '@/lib/services/organization-tax-settings/organization-tax-settings.query'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/settings/taxes/history')({
  component: TaxSettingsHistoryPage,
  head: () => adminTitleHead('History', 'Taxes', 'Settings'),
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('list', 'tax-settings') ||
      !context.ability.can('view', 'audit-logs')
    ) {
      throw notFound()
    }

    await Promise.all([
      context.queryClient.ensureQueryData(
        organizationTaxSettingsQueries.detail({ organizationId: params.orgId })
      ),
      context.queryClient.ensureInfiniteQueryData(
        auditLogQueries.record({
          organizationId: params.orgId,
          subject: 'tax-settings',
          recordId: params.orgId,
        })
      ),
    ])
  },
})

function TaxSettingsHistoryPage() {
  const { orgId } = Route.useParams()
  const path = usePathHelper()

  return (
    <RecordHistoryPage
      backLabel="tax settings"
      backLink={path.taxes.index().link}
      description="Review changes to how delivery fees are handled during tax calculation."
      organizationId={orgId}
      recordId={orgId}
      recordLabel="Tax settings"
      subject="tax-settings"
    />
  )
}
